import 'landing_pages/landing_pages';
import 'billing';
import 'member';
import 'plans';
import 'utils/bubble_popup';
import 'utils/hs_ejs';
import 'utils/mobile';
import 'utils/tracker_marketo';
import { bootFunctions as landingPagesBootFunctions } from 'landing_pages/boot';
import { bootFunctions as billingBootFunctions } from 'billing/boot';
import { bootFunctions as appDirectoryBootFunctions } from 'appdirectory/boot';
import 'eula-confirmation/eula-confirmation';
import { boot, setupBoot } from 'core/boot';

$(document).ready(function () {
    hs.landingpages.init();
});

setupBoot(appDirectoryBootFunctions)
setupBoot(landingPagesBootFunctions)
setupBoot(billingBootFunctions)
boot()
